import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { Vertreter as VermittlerBff } from '@ps20/bff-models';

export interface Vermittler {
  isInkasso?: boolean;
}

export const vermittlerReducer = function (
  sectionState: Vermittler = null,
  action: AnyAction,
): Vermittler {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      return {
        ...sectionState,
        isInkasso: !!(action.payload.vertreter as VermittlerBff).isInkasso,
      };
    }
    default:
      return sectionState;
  }
};
